<template>
    <div class="o-promoPreview" :class="{ selectedPromo: selected }">
        <router-link
            :to="
                subscriptions &&
                subscriptions[0] &&
                subscriptions[0].company_merchant_status === 'inactive'
                    ? `/service/${company.service_id}`
                    : `/promo-details/${id}`
            "
            @click.native="setScroll"
            class="o-promoPreview__link"
        >
            <div class="d-flex o-promoPreview__topRow">
                <div
                    class="d-flex justify-content-between o-promoPreview__heartWrapper"
                >
                    <promotion-preview-heart
                        :id="id"
                        v-if="
                            previewType === 'promo-list' ||
                                previewType === 'promo-later'
                        "
                        @click="favorite => toggleFavorites(id, favorite)"
                    />
                </div>
                <div class="o-promoPreview__imageWrapper">
                    <img
                        :src="logo && logo.urls && logo.urls.small"
                        class="o-promoPreview__image"
                    />
                </div>
                <promotion-preview-small-details
                    class="o-promoPreview__smallDetailsWrapper o-promoPreview__smallDetailsWrapper--desktop"
                    :name="name"
                    :id="id"
                    :type="type"
                    :start-at="start_at"
                    :finish-at="finish_at"
                    :company="company"
                    :total-refund-amount="total_refund_amount"
                    :subscriptions="subscriptions"
                    :preview-type="previewType"
                    :selection-conflict="selectionConflict"
                    :state="state"
                    :prize-amount="prize_amount"
                    :sales-target-thresholds="sales_target_thresholds"
                    :retailer_info="retailer_info"
                />
                <div
                    class="o-promoPreview__chevronWrapper"
                    @click.prevent.stop="showMore = !showMore"
                >
                    <a-icon icon="Dropdown" class="o-promoPreview__chevron" />
                </div>
            </div>
        </router-link>

        <promotion-preview-small-details
            class="o-promoPreview__smallDetailsWrapper o-promoPreview__smallDetailsWrapper--mobile"
            :name="name"
            :id="id"
            :type="type"
            :start-at="start_at"
            :finish-at="finish_at"
            :company="company"
            :total-refund-amount="total_refund_amount"
            :subscriptions="subscriptions"
            :selection-conflict="selectionConflict"
            :preview-type="previewType"
            :state="state"
            :prize-amount="prize_amount"
            :sales-target-thresholds="sales_target_thresholds"
            :retailer_info="retailer_info"
        />

        <div v-if="showMore" class="o-promoPreview__details">
            <promotion-preview-details
                :id="id"
                :start-at="start_at"
                :finish-at="finish_at"
                :state="state"
                :products="products"
                :product-sets="product_sets"
                :discount-text="discount_text"
                :type="type"
                :usage-limit-per-receipt="usage_limit_per_receipt"
            />
        </div>
    </div>
</template>

<script>
import PromotionPreviewSmallDetails from '@/components/promotions/promotionsPreview/PromotionPreviewSmallDetails'
import PromotionPreviewHeart from '@/components/promotions/promotionsPreview/PromotionPreviewHeart'
import PromotionPreviewDetails from '@/components/promotions/promotionsPreview/PromotionPreviewDetails'

export default {
    name: 'PromotionPreview',
    components: {
        PromotionPreviewSmallDetails,
        PromotionPreviewHeart,
        PromotionPreviewDetails
    },
    props: {
        id: { type: Number, default: 0 },
        logo: { type: Object, default: () => {} },
        type: { type: String, default: '' },
        products: { type: Array, default: () => [] },
        product_sets: { type: Array, default: () => [] },
        favorite: { type: Boolean, default: false },
        start_at: { type: String, default: '' },
        finish_at: { type: String, default: '' },
        discount_text: { type: String, default: '' },
        name: { type: String, default: '' },
        company: { type: Object, default: () => {} },
        state: { type: String, default: '' },
        prize_amount: { type: String, default: '' },
        total_refund_amount: { type: Array, default: () => [] },
        subscriptions: { type: Array, default: () => [] },
        eanConflict: { type: Boolean, default: false },
        marketingPromoConflict: { type: Boolean, default: false },
        usage_limit_per_receipt: { type: Number, required: false },
        previewType: {
            validator: function(value) {
                // The value must match one of these strings
                return [
                    'promo-labels',
                    'promo-yours',
                    'promo-finished',
                    'promo-later',
                    'promo-list'
                ].includes(value)
            }
        },
        sales_target_thresholds: { type: Array, default: () => [] },
        retailer_info: { type: String, default: '' }
    },
    computed: {
        selected() {
            return this.$store.getters.getSelectedPromotionBoolean(this.id)
        }
    },
    watch: {
        marketingPromoConflict: function(val) {
            if (val) {
                this.selectionConflict =
                    'Nie możesz zaakceptować tej promocji bez aktywacji usługi organizatora'
            }
        }
    },
    methods: {
        setScroll() {
            this.$store.dispatch('setScrollY', window.scrollY)
        },
        toggleFavorites(promoId, favorite) {
            this.$store.dispatch('toggleFavorites', {
                promoId,
                favorite
            })
        }
    },
    data() {
        return {
            showMore: false,
            selectionConflict: null
        }
    }
}
</script>
